export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          <div className="flex-1 text-center lg:text-left">
            <div className="flex items-center gap-3 mb-2 justify-center lg:justify-start">
              <span className="w-10 h-10 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-information-line text-background-50 text-xl"></i>
              </span>
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">关于我们</h2>
            </div>
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed mt-4 max-w-2xl">
              黑料在线成立于2023年，是国内领先的黑料视频在线观看平台。我们致力于为用户提供海量、高质量的黑料视频正片内容，
              覆盖娱乐圈、网红圈、综艺幕后、影视圈等多个领域的最新爆料资讯。黑料在线坚持每日更新，
              所有黑料视频支持在线播放与免费观看，无需注册即可直接访问。黑料在线已成为广大吃瓜群众获取最新黑料大瓜的首选平台。
              我们的内容团队全天候追踪热点事件，确保黑料在线视频资源始终最新、最全、最真实。
              黑料在线 — 让每一条爆料都有据可查，让每一次吃瓜都不留遗憾。
            </p>
          </div>
          <div className="flex-shrink-0 w-full max-w-sm">
            <div className="aspect-square rounded-lg overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Abstract%20modern%20brand%20visual%20with%20warm%20golden%20amber%20glow%2C%20elegant%20minimalist%20design%2C%20dramatic%20cinematic%20lighting%2C%20sophisticated%20dark%20and%20gold%20contrast%2C%20premium%20editorial%20style%2C%20abstract%20geometric%20composition%2C%20luxurious%20atmosphere&width=600&height=600&seq=about-brand-visual&orientation=squarish"
                alt="黑料在线品牌形象"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}